import escapeStringRegexp from 'escape-string-regexp';

import type * as api from '@gitbook/api-client';
import { Icon } from '@gitbook/spine-icons';
import { PrettyURL, TextInputTextPrefix } from '@gitbook/spine-react';

/**
 * Show the published url with the output of slug changes (if not default).
 */
export function PathOutput(props: { item: api.SiteSpace | api.SiteSection }) {
    const { item } = props;
    return item.urls.published && item.default ? (
        <div className="text-muted text-ui-small">
            <Icon.InfoCircle className="-mt-0.5 mr-1.5 inline-block shrink-0" />
            As the default {item.object === 'site-section' ? 'section' : 'variant'}, this will also
            be available at <PrettyURL>{item.urls.published}</PrettyURL>
        </div>
    ) : null;
}

export function PathPrefix(props: { item: api.SiteSpace | api.SiteSection }) {
    const { item } = props;
    if (!item.urls.published) {
        return null;
    }
    const url = item.default
        ? item.urls.published
        : item.urls.published.replace(new RegExp(`${escapeStringRegexp(item.path)}/$`), '');
    return <TextInputTextPrefix text={url} />;
}
